<template>
  <div class="community2-page">
    <div class="page-shell">
      <aside class="sidebar">
        <div class="sidebar-heading"># 话题</div>
        <div class="sidebar-sub">
          热门话题 · 按热度
          <span class="info-icon">i</span>
        </div>

        <ul class="topic-list">
          <li
            v-for="(topic, index) in topicList"
            :key="topic.name"
            class="topic-item"
          >
            <span
              class="topic-rank"
              :class="{ r1: index === 0, r2: index === 1, r3: index === 2 }"
            >
              {{ index + 1 }}
            </span>
            <span class="topic-hash">#</span>
            <span class="topic-name">{{ topic.name }}</span>
            <span class="topic-heat">{{ topic.heat }}</span>
          </li>
        </ul>

        <div class="sidebar-cta">
          <div class="sidebar-cta-label">参与社区</div>
          <button class="sidebar-post-btn" @click="openLoginModal">
            <span class="plus">+</span> 发布帖子
          </button>
          <div class="sidebar-topics-link">
            查看全部话题 <span>›</span>
          </div>
        </div>
      </aside>

      <main class="main-content">
        <div class="filter-bar">
          <button
            v-for="tab in filterTabs"
            :key="tab"
            class="filter-tab"
            :class="{ active: activeFilter === tab }"
            @click="activeFilter = tab"
          >
            {{ tab }}
          </button>
        </div>

        <div
          class="post-input-card mobile-input-card fade-up"
          @click="openLoginModal"
        >
          <div class="input-avatar">
            <img
              src="/assets/images/community2/post11.jpg"
              alt=""
            >
          </div>

          <div class="input-text">
            <div class="input-title">今天你去了哪里？</div>
            <div class="input-sub">
              分享路线 / 载具 / 改装 / 影像
            </div>
          </div>

          <div class="input-plus">+</div>
        </div>

        <div class="masonry">
            <div
                v-for="(column, colIndex) in masonryColumns"
                :key="colIndex"
                class="masonry-col"
            >
                <div
                v-if="colIndex === 0"
                class="post-input-card desktop-input-card fade-up"
                @click="openLoginModal"
                >
                <div class="input-avatar">
                  <img

                    src="/assets/images/community2/post11.jpg"

                    alt=""
                  >
                </div>
                <div class="input-text">
                    <div class="input-title">今天你去了哪里？</div>
                    <div class="input-sub">分享路线 / 载具 / 改装 / 影像</div>
                </div>
                <div class="input-plus">+</div>
                </div>

                <div
                v-for="(item, index) in column"
                :key="item.img + index"
                class="post-card fade-up"
                :style="{ transitionDelay: item.delay }"
                >
                <div class="card-img" :class="item.ratio">
                    <img :src="imgUrlPrefix + item.img" :alt="item.titleText || item.title" />
                </div>

                <div class="card-body">
                    <div class="card-title" v-html="item.title"></div>
                </div>

                <div class="card-footer">
                    <div class="card-user">
                    <div class="card-avatar">{{ item.avatar }}</div>
                    <span class="card-username">{{ item.username }}</span>
                    </div>
                    <div class="card-stats">
                    <span class="stat">♡ {{ item.like }}</span>
                    <span class="stat">◦ {{ item.comment }}</span>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div v-if="!hasPosts" class="empty-state">

                暂无内容

                </div>
        <div class="mobile-topic-card">
            <div class="mobile-topic-head">
                <span># 热门话题</span>
                <span>查看全部 ·</span>
            </div>

            <div class="mobile-topic-grid">
                <div
                v-for="(topic, index) in topicList.slice(0, 8)"
                :key="topic.name"
                class="mobile-topic-item"
                >
                <span>{{ index + 1 }}</span>
                <b># {{ topic.name }}</b>
                <em>{{ topic.heat }}</em>
                </div>
            </div>
        </div>

        <div class="load-more-wrap">
          <button
            class="load-more"
            :disabled="loadMoreDisabled"
            :style="loadMoreStyle"
            @click="loadMore"
          >
            {{ loadMoreText }}
          </button>
        </div>
      </main>
    </div>

    <div
      class="modal-overlay"
      :class="{ active: loginModalShow }"
      @click="handleOverlayClick"
    >
      <div class="modal-box">
        <button class="modal-close" @click="closeLoginModal">×</button>

        <div class="modal-tabs">
          <button
            class="modal-tab"
            :class="{ active: activeTab === 'login' }"
            @click="switchTab('login')"
          >
            登录
          </button>
          <button
            class="modal-tab"
            :class="{ active: activeTab === 'register' }"
            @click="switchTab('register')"
          >
            注册
          </button>
        </div>

        <div class="modal-panel" :class="{ active: activeTab === 'login' }">
          <form class="modal-form" onsubmit="return false;">
            <input type="text" placeholder="手机号 / 邮箱" autocomplete="username" />
            <input type="password" placeholder="密码" autocomplete="current-password" />
            <button class="modal-submit">登录</button>
          </form>
        </div>

        <div class="modal-panel" :class="{ active: activeTab === 'register' }">
          <form class="modal-form" onsubmit="return false;">
            <input type="text" placeholder="手机号" autocomplete="tel" />
            <input type="text" placeholder="用户名" autocomplete="username" />
            <input type="password" placeholder="设置密码" autocomplete="new-password" />
            <input type="password" placeholder="确认密码" autocomplete="new-password" />
            <button class="modal-submit">注册</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Community2',
  data() {
    return {
      imgUrlPrefix: '/assets/images/community2/',
      activeFilter: '全部',
      isMobile: false,
      filterTabs: ['全部', '路线', '载具', '改装', '活动', '影像', '问答', '最新'],
      loginModalShow: false,
      activeTab: 'login',
      loadMoreText: '加载更多 ↓',
      loadMoreDisabled: false,

      topicList: [
        { name: '巴丹吉林', heat: '12.8k' },
        { name: 'N30', heat: '9.6k' },
        { name: '穿越', heat: '8.2k' },
        { name: 'T1改装', heat: '6.7k' },
        { name: '露营', heat: '5.9k' },
        { name: '路线攻略', heat: '4.8k' },
        { name: '装备清单', heat: '4.2k' },
        { name: 'UTV', heat: '3.6k' },
        { name: '越野摄影', heat: '3.1k' },
        { name: '补给点', heat: '2.7k' },
      ],

      postList: [
        {
          title: '212 METTA N30 洛基',
          titleText: '212 METTA N30 洛基',
          img: 'post1.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.04s',
          category: '活动',
        },
        {
          title: 'PRO系列，如约而至',
          titleText: 'PRO系列，如约而至',
          img: 'post2.jpg',
          ratio: 'ratio-mid',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.06s',
          category: '活动',
        },
        {
          title: '212 METTA N30系列三门版',
          titleText: '212 METTA N30系列三门版',
          img: 'post3.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.08s',
          category: '改装',
        },
        {
          title: '共历环球每一程',
          titleText: '共历环球每一程',
          img: 'post4.jpg',
          ratio: 'ratio-poster',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.10s',
          category: '活动',
        },
        {
          title: 'METTA Performance系列',
          titleText: 'METTA Performance系列',
          img: 'post5.jpg',
          ratio: 'ratio-mid',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.12s',
          category: '活动',
        },
        {
          title: '越野天花板 ✨ 212 METTA这抹紫色杀疯了',
          titleText: '越野天花板 212 METTA这抹紫色杀疯了',
          img: 'post6.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.14s',
          category: '活动',
        },
        {
          title: '被这台METTA硬控了！',
          titleText: '被这台METTA硬控了',
          img: 'post7.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.16s',
          category: '活动',
        },
        {
          title: '谁懂？被212展台狠狠种草！',
          titleText: '谁懂 被212展台狠狠种草',
          img: 'post8.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.18s',
          category: '活动',
        },
        {
          title: 'METTA Classic系列',
          titleText: 'METTA Classic系列',
          img: 'post9.jpg',
          ratio: 'ratio-mid',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.20s',
          category: '活动',
        },
        {
          title: 'METTA赛事文化基因注入，尽显环塔本色',
          titleText: 'METTA赛事文化基因注入，尽显环塔本色',
          img: 'post10.jpg',
          ratio: 'ratio-tall',
          avatar: 'M',
          username: 'METTA 超级管理员',
          like: 0,
          comment: 0,
          delay: '.22s',
          category: '活动',
        },
      ],
    }
  },
  computed: {

    filteredPostList() {

        if (
        this.activeFilter === '全部' ||
        this.activeFilter === '最新'
        ) {
        return this.postList
        }

        return this.postList.filter(
        item => item.category === this.activeFilter
        )

    },

    masonryColumns() {
        const list = this.filteredPostList
        const colCount = this.isMobile ? 2 : 4

        if (!list.length) {
            return Array.from({ length: colCount }, () => [])
        }

        const columns = Array.from({ length: colCount }, () => [])

        list.forEach((item, index) => {
            columns[index % colCount].push(item)
        })

        return columns
        },

    hasPosts() {

        return this.filteredPostList.length > 0

    },

    loadMoreStyle() {

        return this.loadMoreDisabled
        ? { opacity: '0.35', cursor: 'default' }
        : {}

    },

    },
  mounted() {

    this.checkMobile()

    window.addEventListener('resize', this.checkMobile)

    this.initFadeUp()

    },

    beforeDestroy() {

    window.removeEventListener('resize', this.checkMobile)

    document.body.style.overflow = ''

    },
  watch: {

    activeFilter() {

        this.$nextTick(() => {

        this.initFadeUp()

        })

    },

},
  methods: {
    checkMobile() {

        this.isMobile = window.innerWidth <= 900

    },
    openLoginModal() {
      window.open(

      'https://community-metta.sixeco.com/',

      '_blank'

    )
    },
    closeLoginModal() {
      this.loginModalShow = false
      document.body.style.overflow = ''
    },
    handleOverlayClick(event) {
      if (event.target.classList.contains('modal-overlay')) {
        this.closeLoginModal()
      }
    },
    switchTab(tab) {
      this.activeTab = tab
    },
    initFadeUp() {
        const items = this.$el.querySelectorAll('.fade-up:not(.visible)')

        if (!('IntersectionObserver' in window)) {
            items.forEach(el => el.classList.add('visible'))
            return
        }

        const io = new IntersectionObserver(entries => {
            entries.forEach(entry => {
            if (!entry.isIntersecting) return
            entry.target.classList.add('visible')
            io.unobserve(entry.target)
            })
        }, { threshold: 0.04 })

        items.forEach(el => io.observe(el))
        },
    loadMore() {
      if (this.loadMoreDisabled) return

      this.loadMoreText = '加载中…'

      window.setTimeout(() => {
        this.loadMoreText = '已加载全部'
        this.loadMoreDisabled = true
      }, 800)
    },
  },
}
</script>

<style scoped>
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.community2-page {
  --bg: #f7f7f5;
  --card: #ffffff;
  --bdr: #e5e5e2;
  --ink: #080808;
  --mid: #5e5e5c;
  --mute: #a6a6a2;
  --orange: #f6a623;
  --img-bg: #dedbd5;

  min-height: 100vh;
  background: var(--bg);
  color: var(--ink);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 300;
  line-height: 1.5;
  overflow-x: hidden;
}

.page-shell {
  display: block;
  min-height: 100vh;
  padding-top: 32px;
}

.sidebar {
  position: fixed;

  left: 0;

  top: 32px;

  z-index: 20;

  display: flex;

  flex-direction: column;

  width: 220px;

  height: calc(100vh - 32px);

  padding: 32px 24px 30px 28px;

  background: #ffffff;

  border-right: 1px solid var(--bdr);

  overflow: hidden;
}

.sidebar-heading {
  margin-bottom: 3px;
  font-size: 18px;
  font-weight: 300;
  color: var(--ink);
  letter-spacing: -0.3px;
}

.sidebar-sub {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 20px;
  font-size: 10px;
  letter-spacing: 0.5px;
  color: var(--mute);
}

.sidebar-sub .info-icon {
  width: 13px;
  height: 13px;
  border: 1px solid var(--mute);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: var(--mute);
}

.topic-list {
  flex: 1;
  list-style: none;
  overflow-y: auto;
  scrollbar-width: none;
}

.topic-list::-webkit-scrollbar {
  display: none;
}

.topic-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.045);
  cursor: pointer;
  transition: opacity 0.15s;
}

.topic-item:last-child {
  border-bottom: none;
}

.topic-item:hover {
  opacity: 0.62;
}

.topic-rank {
  width: 14px;
  flex-shrink: 0;
  text-align: right;
  font-size: 11px;
  font-family: 'Roboto Mono', monospace;
  font-weight: 300;
  color: var(--mute);
}

.topic-rank.r1 {
  color: #e02020;
}

.topic-rank.r2 {
  color: #e05020;
}

.topic-rank.r3 {
  color: #e07020;
}

.topic-hash {
  flex-shrink: 0;
  font-size: 11px;
  color: var(--mute);
}

.topic-name {
  flex: 1;
  font-size: 13px;
  font-weight: 300;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-heat {
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  font-size: 9px;
  letter-spacing: 0.5px;
  color: var(--mute);
  font-family: 'Roboto Mono', monospace;
}

.topic-heat::before {
  content: '';
  width: 10px;
  height: 10px;
  display: inline-block;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23a6a6a4' stroke-width='1.5'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z'/%3E%3C/svg%3E") center/contain no-repeat;
}

.sidebar-cta {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--bdr);
}

.sidebar-cta-label {
  margin-bottom: 12px;
  font-size: 10px;
  letter-spacing: 1px;
  color: var(--mute);
}

.sidebar-post-btn {
  width: 100%;
  height: 42px;
  border: none;
  background: var(--ink);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  letter-spacing: 1.5px;
  font-family: inherit;
  font-weight: 300;
  cursor: pointer;
  transition: opacity 0.15s;
}

.sidebar-post-btn:hover {
  opacity: 0.82;
}

.sidebar-post-btn .plus {
  font-size: 16px;
  line-height: 1;
}

.sidebar-topics-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 11px;
  color: var(--mid);
  cursor: pointer;
  transition: color 0.15s;
}

.sidebar-topics-link:hover {
  color: var(--ink);
}

.main-content {
  margin-left: 220px;
  padding: 0 34px 80px;
  background: var(--bg);
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px 0 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--bdr);
}

.filter-tab {
  height: 34px;
  padding: 0 18px;
  border: 1px solid var(--bdr);
  background: #ffffff;
  color: var(--mid);
  font-size: 12px;
  letter-spacing: 0.3px;
  cursor: pointer;
  font-family: inherit;
  font-weight: 300;
  white-space: nowrap;
  transition: all 0.15s;
}

.filter-tab.active {
  background: var(--ink);
  color: #ffffff;
  border-color: var(--ink);
}

.filter-tab:hover:not(.active) {
  border-color: var(--ink);
  color: var(--ink);
}

.masonry {
  display: grid;

  grid-template-columns: repeat(4, minmax(0, 1fr));

  gap: 24px;

  align-items: start;
}
.masonry-col {

  display: flex;

  flex-direction: column;

  gap: 24px;

}

.post-card,
.post-input-card {
  width: 100%;

  background: var(--card);

  border: 1px solid var(--bdr);

  cursor: pointer;

  margin-bottom: 0;

  break-inside: auto;
}

.post-card {
  display: block;
  transition: opacity 0.2s;
}

.post-card:hover {
  opacity: 0.88;
}

.post-input-card {

  height: 72px;

  padding: 0 16px;

  display: flex;

  align-items: center;

  gap: 12px;

}

.input-avatar {

  width: 36px;

  height: 36px;

  border-radius: 50%;

  overflow: hidden;

  flex-shrink: 0;

}
.input-avatar img{

  width:100%;

  height:100%;

  object-fit:cover;

  display:block;

}

.input-text {
  flex: 1;
  min-width: 0;
}

.input-title {

  margin-bottom: 2px;

  font-size: 13px;

  line-height: 1.2;

  color: #111;

  font-weight: 400;

}

.input-sub {

  font-size: 9px;

  color: #b7b7b7;

  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

}

.input-plus {

  width: 32px;

  height: 32px;

  border-radius: 50%;

  background: #000;

  color: #fff;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

  font-size: 22px;

  line-height: 1;

  margin-left: auto;

}

.card-img {
  width: 100%;
  overflow: hidden;
  position: relative;
  background: var(--img-bg);
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ratio-tall {
  aspect-ratio: 3 / 4.25;
}

.ratio-poster {

  aspect-ratio: 3 / 6.8;

}

.ratio-mid {
  aspect-ratio: 4 / 3;
}

.ratio-sq {
  aspect-ratio: 1 / 1;
}

.ratio-wide {
  aspect-ratio: 16 / 9;
}

.ratio-3-2 {
  aspect-ratio: 3 / 2;
}

.card-body {
  padding: 13px 14px 10px;
}

.card-title {
  font-size: 14px;
  font-weight: 300;
  color: var(--ink);
  letter-spacing: -0.15px;
  line-height: 1.45;
  margin-bottom: 0;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.055);
  padding: 8px 14px;
}

.card-user {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  min-width: 0;
}

.card-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--orange);
  color: #ffffff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  overflow: hidden;
}

.card-username {
  font-size: 10px;
  letter-spacing: 0.2px;
  color: var(--mute);
  font-family: 'Roboto Mono', monospace;
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.stat {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-family: 'Roboto Mono', monospace;
  font-weight: 300;
  color: var(--mute);
}

.fade-up {
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fade-up.visible {
  opacity: 1;
  transform: translateY(0);
}

.load-more-wrap {
  text-align: center;
  padding: 48px 0 20px;
}

.empty-state {
  width: 100%;
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mute);
  font-size: 14px;
  letter-spacing: 1px;
}

.load-more {
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--mid);
  background: #ffffff;
  border: 1px solid var(--bdr);
  padding: 11px 38px;
  cursor: pointer;
  font-family: inherit;
  font-weight: 300;
  transition: all 0.15s;
}

.load-more:hover:not(:disabled) {
  border-color: var(--ink);
  color: var(--ink);
}

.modal-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 8, 0.6);
  backdrop-filter: blur(4px);
  z-index: 2000;
  align-items: center;
  justify-content: center;
}

.modal-overlay.active {
  display: flex;
}

.modal-box {
  background: var(--card);
  border: 1px solid var(--bdr);
  padding: 48px;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 24px;
  background: none;
  border: none;
  font-size: 20px;
  color: var(--mute);
  cursor: pointer;
  font-family: inherit;
  line-height: 1;
}

.modal-tabs {
  display: flex;
  border-bottom: 1px solid var(--bdr);
  margin-bottom: 32px;
}

.modal-tab {
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--mute);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0 0 12px;
  margin-right: 24px;
  cursor: pointer;
  font-family: inherit;
  font-weight: 300;
}

.modal-tab.active {
  color: var(--ink);
  border-bottom-color: var(--ink);
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-form input {
  border: 1px solid var(--bdr);
  background: var(--bg);
  padding: 12px 16px;
  font-size: 13px;
  font-family: inherit;
  font-weight: 300;
  color: var(--ink);
  outline: none;
}

.modal-form input:focus {
  border-color: var(--ink);
}

.modal-form input::placeholder {
  color: var(--mute);
}

.modal-submit {
  background: var(--ink);
  color: var(--bg);
  border: 1px solid var(--ink);
  padding: 13px;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: 300;
  cursor: pointer;
  margin-top: 6px;
}

.modal-panel {
  display: none;
}

.modal-panel.active {
  display: block;
}

@media (max-width: 1400px) {
  .masonry {
    columns: 3;
  }
}

@media (max-width: 1100px) {
  .masonry {
    columns: 2;
  }
}

@media (max-width: 900px) {

  .page-shell {
    display: block;

    column-count: auto;

    column-gap: 0;
  }
  

  .sidebar {
    display: none;
  }

  .main-content {
    margin-left: 0;
    padding: 36px 8px 70px;
    background: #f7f7f5;
  }

  .filter-bar {
    position: relative;
    z-index: 1;
    overflow-x: auto;
    gap: 8px;
    padding: 10px 2px 12px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--bdr);
    scrollbar-width: none;
  }

  .filter-bar::-webkit-scrollbar {
    display: none;
  }

  .filter-tab {
    height: 30px;
    padding: 0 14px;
    font-size: 11px;
    flex-shrink: 0;
  }

  .masonry {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    align-items: start;
  }

  .masonry-col {
    gap: 8px;
  }

  .post-card,
  .post-input-card {
    width: 100%;
    margin-bottom: 0;
    border: 1px solid #e7e7e4;
    background: #fff;
  }

  .post-input-card {
    height: 64px;
    padding: 0 12px;
    grid-column: 1 / -1;
  }

  .input-avatar {
    width: 32px;
    height: 32px;
  }

  .input-title {
    font-size: 12px;
  }

  .input-sub {
    font-size: 9px;
  }

  .input-plus {
    width: 30px;
    height: 30px;
    font-size: 20px;
  }

  .card-img {
    background: #e5e3de;
  }

  .ratio-tall {
    aspect-ratio: 3 / 4.35;
  }

  .ratio-poster {
    aspect-ratio: 3 / 5.8;
  }

  .ratio-mid {
    aspect-ratio: 4 / 3.05;
  }

  .ratio-sq {
    aspect-ratio: 1 / 1;
  }

  .ratio-wide {
    aspect-ratio: 16 / 9;
  }

  .ratio-3-2 {
    aspect-ratio: 3 / 2;
  }

  .card-body {
    padding: 8px 8px 6px;
  }

  .card-title {
    font-size: 11px;
    line-height: 1.45;
    font-weight: 400;
  }

  .card-footer {
    padding: 6px 8px;
    gap: 4px;
  }

  .card-avatar {
    width: 16px;
    height: 16px;
    font-size: 7px;
  }

  .card-username {
    font-size: 8px;
  }

  .card-stats {
    gap: 4px;
  }

  .stat {
    font-size: 8px;
  }

  .load-more-wrap {
    padding: 30px 0 20px;
  }

  .load-more {
    width: 100%;
    height: 38px;
    font-size: 10px;
  }

  .empty-state {
    grid-column: 1 / -1;
    min-height: 180px;
  }

  .modal-box {
    width: calc(100% - 32px);
    padding: 36px 24px;
  }

  .fade-up {

    opacity: 1 !important;

    transform: none !important;

  }

  .fade-up.visible {

    opacity: 1 !important;

    transform: none !important;

  }
}
.mobile-topic-card {
  display: none;
}

.mobile-input-card {

  display: none;

}

@media (max-width: 900px) {

  .mobile-topic-card {
    display: block;
    margin: 16px 0 18px;
    padding: 14px 12px;
    background: #fff;
    border: 1px solid var(--bdr);
  }

  .mobile-input-card {

    display: flex;

  }

  .desktop-input-card {

    display: none;

  }

  .mobile-input-card{

  width:100%;

  height:72px;

  margin-bottom:12px;

}

  .mobile-topic-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 12px;
    color: #111;
  }

  .mobile-topic-head span:last-child {
    font-size: 10px;
    color: #aaa;
  }

  .mobile-topic-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 14px;
    row-gap: 10px;
  }

  .mobile-topic-item {
    display: grid;
    grid-template-columns: 16px 1fr auto;
    align-items: center;
    gap: 5px;
    font-size: 10px;
    color: #999;
  }

  .mobile-topic-item span {
    color: #d66;
    font-size: 10px;
  }

  .mobile-topic-item b {
    font-weight: 400;
    color: #222;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .mobile-topic-item em {
    font-style: normal;
    font-size: 9px;
    color: #aaa;
  }
}
</style>
